import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { API } from '../../shared/api.constants';
import { map } from 'rxjs/operators';
import {Observable} from 'rxjs/Rx';

@Injectable()
export class ItemService {
	private resourceVerify = API.host + 'InvoicePortal/VerifyXml';
	private resourceGetInvoiceTemplate = API.host + 'InvoicePortal/getInvoiceTemplate';
	private resourceGetInvoiceByInfoXml = API.host + 'InvoicePortal/getInvoiceByInfoXml';

	constructor(
		private http: HttpClient
	) { }

	public uploadFile(fileToUpload: File) {
		const _formData = new FormData();
		//_formData.append('file', fileToUpload, fileToUpload.name);   
		_formData.append(fileToUpload.name, fileToUpload);
		return this.http.post(this.resourceVerify, _formData)
	}
	getInvoiceTemplate(code: string): Observable<any> {
		code = code.replace("/","");
		return this.http.get(`${this.resourceGetInvoiceTemplate}/${code}`).map((res: Response) => {
            // if (!res || !res.json) {
            //     throw 'Invalid Code';
			// }
			// console.log(res.json().data);
            return res;
        });
	}
	getInvoiceByInfoXml(invoiceNo: string, symbol: string, invoiceCode: string): Observable<any> {
		invoiceCode = invoiceCode.replace("/","");
		symbol = symbol.replace("/","");
		return this.http.get(`${this.resourceGetInvoiceByInfoXml}/${invoiceNo}/${symbol}/${invoiceCode}`).map((res: Response) => {
            return res;
        });
	}
}
